import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import ninNikuImg from "../assets/images/nin-niku.jpg";
import yarigaiImg from "../assets/images/yarigai.jpg";
import tryImg from "../assets/images/try.jpg";
import missionImg from "../assets/images/mission.jpg";
import visionImg from "../assets/images/vision.jpg";
import Footer from "../components/Footer";

const HomeContainer = styled.div``;

const MissionVisionSection = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const MissionVisionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;

const MissionVisionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MissionVisionImage = styled.div`
  flex: 1;
  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const MissionVisionContent = styled.div`
  flex: 1;

  h3 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: #333;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #666;
  }
`;

const Section = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const ServiceCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const ServiceImage = styled.div`
  height: 200px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: #0090a0;
`;

const ServiceContent = styled.div`
  padding: 1.5rem;

  h3 {
    font-size: 1.5rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: #333;
  }

  p {
    color: #666;
    margin-bottom: 1rem;
  }
`;

const Button = styled(Link)`
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background-color: #0090a0;
  color: #fff;
  border-radius: 4px;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #007580;
  }
`;

const Home = () => {
  return (
    <>
      <HomeContainer>
        <Header
          title="テクノロイグ株式会社"
          subtitle="ITエンジニアに、やりがいある仕事との出会いを届ける"
          showButton={false}
        />

        <MissionVisionSection>
          <MissionVisionContainer>
            <MissionVisionItem data-aos="fade-up">
              <MissionVisionImage>
                <img src={missionImg} alt="ミッション" />
              </MissionVisionImage>
              <MissionVisionContent>
                <h3>ミッション</h3>
                <p>
                  変化のスピードが増す現代、エンジニアはどの技術や役割に触れるべきかを能動的に考え、実行することが不可欠です。
                  しかし、レガシーな環境や単調な作業に閉じ込められ、成長の手応えを失い
                  、将来に不安を覚えるエンジニアは少なくありません。
                  私たちは、一人ひとりが「本当にやりたい」プロジェクトや領域に挑戦できる機会をできる限り模索し
                  、 実現することで、一人でも多くの IT
                  エンジニアにやりがいある仕事を届けたいと考えています。
                </p>
              </MissionVisionContent>
            </MissionVisionItem>

            <MissionVisionItem data-aos="fade-up" data-aos-delay="100">
              <MissionVisionContent>
                <h3>ビジョン</h3>
                <p>
                  「より多くの人がポジティブに仕事ができる社会を作る」
                  <br />
                  私たちはこのビジョン実現のために、まず足元のIT事業から変革を起こし、
                  「ITエンジニアにやりがいある仕事との出会いを届ける」というミッションを起点に、ポジティブな働き方が連鎖する社会をつくっていきます。
                </p>
              </MissionVisionContent>
              <MissionVisionImage>
                <img src={visionImg} alt="ビジョン" />
              </MissionVisionImage>
            </MissionVisionItem>
          </MissionVisionContainer>
        </MissionVisionSection>

        <Section>
          <SectionTitle data-aos="fade-up">事業内容</SectionTitle>
          <ServicesGrid>
            <ServiceCard data-aos="fade-up" data-aos-delay="100">
              <ServiceImage style={{ backgroundColor: "#0c1e2f" }}>
                <img
                  src={yarigaiImg}
                  alt="システム開発"
                  style={{
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              </ServiceImage>
              <ServiceContent>
                <h3>システム開発の受託・SES</h3>
                <Button to="/products">詳細を見る</Button>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard data-aos="fade-up" data-aos-delay="200">
              <ServiceImage style={{ backgroundColor: "#0c1e2f" }}>
                <img
                  src={tryImg}
                  alt="IT教育"
                  style={{
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              </ServiceImage>
              <ServiceContent>
                <h3>IT教育</h3>
                <Button to="/products">詳細を見る</Button>
              </ServiceContent>
            </ServiceCard>

            <ServiceCard data-aos="fade-up" data-aos-delay="300">
              <ServiceImage style={{ backgroundColor: "#c78543" }}>
                <img
                  src={ninNikuImg}
                  alt="農業"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </ServiceImage>
              <ServiceContent>
                <h3>農業</h3>
                <Button to="/products">詳細を見る</Button>
              </ServiceContent>
            </ServiceCard>
          </ServicesGrid>
        </Section>
      </HomeContainer>
      <Footer />
    </>
  );
};

export default Home;
